const trustBadges = [
  { icon: "ri-shield-check-fill", label: "Fully Insured", sub: "Public liability on every job" },
  { icon: "ri-award-fill", label: "10+ Years Experience", sub: "Serving Kent since 2013" },
  { icon: "ri-user-smile-fill", label: "500+ Happy Customers", sub: "Homes & businesses covered" },
  { icon: "ri-map-pin-2-fill", label: "Local Experts", sub: "Based in Northfleet, Kent" },
];

function StarRow({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`ri-star-fill text-sm ${i < count ? "text-yellow-400" : "text-gray-300"}`}
        ></i>
      ))}
    </div>
  );
}

export default function TrustStrip() {
  return (
    <section className="bg-[#F0F6FF] border-t border-[#D6E8FF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        {/* Heading */}
        <div className="text-center mb-10">
          <p className="text-[#1A3A6B] font-heading font-semibold text-sm uppercase tracking-widest mb-2">
            Trusted by Hundreds Across Kent
          </p>
          <h3
            className="font-heading font-800 text-[#0F2040]"
            style={{ fontSize: "clamp(1.4rem, 2.5vw, 1.9rem)", fontWeight: 800 }}
          >
            Rated Excellent by Our Customers
          </h3>
        </div>

        {/* Review Badges */}
        <div className="flex flex-col sm:flex-row justify-center gap-5 mb-12">
          {/* Google Badge */}
          <div className="flex items-center gap-4 bg-white rounded-2xl px-7 py-5 border border-gray-100 min-w-[220px]">
            <div className="w-11 h-11 flex items-center justify-center flex-shrink-0">
              {/* Google G icon using Remix */}
              <i className="ri-google-fill text-3xl text-[#EA4335]"></i>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="font-heading font-800 text-[#0F2040] text-2xl leading-none" style={{ fontWeight: 800 }}>4.9</span>
                <StarRow count={5} />
              </div>
              <p className="text-gray-500 font-body text-xs">Google Reviews</p>
              <p className="text-[#1E88E5] font-body text-xs font-semibold mt-0.5">50+ reviews</p>
            </div>
          </div>

          {/* Facebook Badge */}
          <div className="flex items-center gap-4 bg-white rounded-2xl px-7 py-5 border border-gray-100 min-w-[220px]">
            <div className="w-11 h-11 flex items-center justify-center flex-shrink-0">
              <i className="ri-facebook-circle-fill text-3xl text-[#1877F2]"></i>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="font-heading font-800 text-[#0F2040] text-2xl leading-none" style={{ fontWeight: 800 }}>4.8</span>
                <StarRow count={5} />
              </div>
              <p className="text-gray-500 font-body text-xs">Facebook Reviews</p>
              <p className="text-[#1E88E5] font-body text-xs font-semibold mt-0.5">30+ reviews</p>
            </div>
          </div>

          {/* Checkatrade-style Badge */}
          <div className="flex items-center gap-4 bg-white rounded-2xl px-7 py-5 border border-gray-100 min-w-[220px]">
            <div className="w-11 h-11 flex items-center justify-center bg-[#EBF4FF] rounded-xl flex-shrink-0">
              <i className="ri-medal-fill text-2xl text-[#1E88E5]"></i>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="font-heading font-800 text-[#0F2040] text-2xl leading-none" style={{ fontWeight: 800 }}>9.8</span>
                <span className="text-xs font-body text-gray-400">/10</span>
              </div>
              <p className="text-gray-500 font-body text-xs">Checkatrade Score</p>
              <p className="text-[#1E88E5] font-body text-xs font-semibold mt-0.5">Verified trader</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#D6E8FF] mb-12"></div>

        {/* Trust Badges Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {trustBadges.map((badge) => (
            <div
              key={badge.label}
              className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 border border-gray-100"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#EBF4FF] rounded-xl flex-shrink-0">
                <i className={`${badge.icon} text-[#1E88E5] text-xl`}></i>
              </div>
              <div>
                <p className="font-heading font-700 text-[#0F2040] text-sm leading-tight" style={{ fontWeight: 700 }}>
                  {badge.label}
                </p>
                <p className="text-gray-400 font-body text-xs mt-0.5">{badge.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
